import { AccordionSummary } from '@mui/material';
import React from 'react';

const AccordionSummaryCustom = (props) => {
    const { children, sx, ...otherProps } = props;
    return (
        <AccordionSummary 
            sx={{
                '&.Mui-expanded': {
                    minHeight: 48
                },
                '& .MuiAccordionSummary-content.Mui-expanded': {
                    margin: 0
                },
                ...sx
            }}
            {...otherProps}
        >
            {children}
        </AccordionSummary>
    );
}

export default AccordionSummaryCustom;
